import React, { useEffect, useState, useCallback } from 'react';
import { Grid, TableCell, TableRow } from '@material-ui/core';
import _debounce from 'lodash/debounce';
import _ from 'lodash';
import PropTypes from 'prop-types';

import API from 'apis/API';
import Messages from 'utils/Messages';
import BaseInput from 'components/Form/BaseInput';
import Select from 'components/Form/Select';
import DateInput from 'components/Form/DateInput';

const events = [
	'Akceptacja raportu A',
	'Akceptacja raportu B',
	'Blokada IP',
	'Blokada logowania',
	'Edycja karty własności intelektualnej zadania badawczego',
	'Edycja podstrony',
	'Edycja raportu A zadania badawczego',
	'Edycja raportu B zadania badawczego',
	'Edycja roli',
	'Edycja tłumaczeń',
	'Edycja użytkownika',
	'Edycja wniosku o przekazanie środków',
	'Edycja zadania badawczego',
	'Kod OTP błędny',
	'Kod OTP wygasł',
	'Kod OTP wysłany',
	'Konto nieaktywne',
	'Logowanie nieudane',
	'Logowanie udane',
	'Odrzucenie raportu A',
	'Odrzucenie raportu B',
	'Pobranie karty WI',
	'Pobranie karty ochrony i komercjalizacji WI',
	'Pobranie listy informacji o sposobie wydatkowania środków',
	'Pobranie listy kart własności intelektualnej',
	'Pobranie listy wniosków o przekazanie środków finansowych',
	'Pobranie listy zadań badawczych',
	'Pobranie pliku eksportu raportu A zadania badawczego',
	'Pobranie pliku eksportu raportu B zadania badawczego',
	'Pobranie pliku eksportu zadania badawczego',
	'Pobranie pliku eksportu zespołu badawczego raportu A zadania badawczego',
	'Pobranie pliku',
	'Pobranie szczegółowych informacji o sposobie wydatkowania środków',
	'Pobranie wniosku o przekazanie środków',
	'Przypomnienie hasła',
	'Reset hasła',
	'Usunięcie folderu',
	'Usunięcie karty własności intelektualnej zadania badawczego',
	'Usunięcie karty własności intelektualnej zadania badawczego',
	'Usunięcie pliku',
	'Usunięcie raportu A zadania badawczego',
	'Usunięcie raportu B zadania badawczego',
	'Usunięcie roli',
	'Usunięcie użytkownika',
	'Usunięcie wniosku o przekazanie środków',
	'Usunięcie zadania badawczego',
	'Utworzenie folderu',
	'Utworzenie karty własności intelektualnej zadania badawczego',
	'Utworzenie raportu A zadania badawczego',
	'Utworzenie raportu B zadania badawczego',
	'Utworzenie roli',
	'Utworzenie użytkownika',
	'Utworzenie wniosku o przekazanie środków',
	'Utworzenie zadania badawczego',
	'Załadowanie pliku',
];
const eventOptions = events.map(v => ({ label: v, value: v }));

const FilterRow = ({ onChange }) => {
	const [filters, setFilters] = useState({
		id: '',
		user_id: '',
		role_id: '',
		ip: '',
		start_date: '',
		end_date: '',
		event: '',
		event_string: '',
	});
	const [users, setUsers] = useState([]);
	const [roles, setRoles] = useState([]);
	const [dateError, setDateError] = useState(null);

	useEffect(() => {
		API.users.all().then(res => setUsers(res.data?.data || []));
		API.roles.all().then(res => setRoles(res.data?.data || []));
	}, []);

	useEffect(() => {
		let _filters = _.pickBy(filters);

		if ((!!filters.start_date && !!filters.end_date) && (filters.start_date > filters.end_date)) {
			setDateError(prev => ({ ...prev, end_date: Messages.AfterStartDate }));
			return;
		}
		setDateError(null);
		handleChangeSearch(_filters);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filters]);

	const handleChange = e => {
		const { name } = e.target;
		const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
		setFilters(prev => ({ ...prev, [name]: value }));
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleChangeSearch = useCallback(_debounce((filters) => onChange(filters), 500), []);

	return (
		<TableRow>
			<TableCell>
				<BaseInput
					placeholder="Wpisz"
					name="id"
					value={filters.id}
					onChange={handleChange}
				/>
			</TableCell>
			<TableCell>
				<Select
					options={users}
					name="user_id"
					valueField="id"
					labelField={['firstname', 'surname']}
					value={filters?.user_id}
					onChange={handleChange}
					displayEmpty
					emptyLabel="Wybierz użytkownika"
					gutterBottom={false}
				/>
			</TableCell>
			<TableCell>
				<Select
					options={roles}
					name="role_id"
					valueField="id"
					labelField="name"
					value={filters?.role_id}
					onChange={handleChange}
					displayEmpty
					emptyLabel="Wybierz rola"
					gutterBottom={false}
				/>
			</TableCell>
			<TableCell>
				<BaseInput
					name="ip"
					value={filters.ip}
					onChange={handleChange}
				/>
			</TableCell>
			<TableCell>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6}>
						<DateInput
							name="start_date"
							value={filters.start_date}
							onChange={handleChange}
							gutterBottom={false}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<DateInput
							name="end_date"
							value={filters.end_date}
							onChange={handleChange}
							error={dateError?.end_date}
							gutterBottom={false}
						/>
					</Grid>
				</Grid>
			</TableCell>
			<TableCell>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={8}>
						<Select
							options={eventOptions}
							name="event"
							value={filters?.event}
							onChange={handleChange}
							gutterBottom={false}
							displayEmpty
							emptyLabel="Wybierz zdarzenie"
						/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<BaseInput
							name="event_string"
							value={filters.event_string}
							onChange={handleChange}
							placeholder="Dodatkowy filtr"
							fullWidth
						/>
					</Grid>
				</Grid>
			</TableCell>
		</TableRow>
	);
};

FilterRow.propTypes = {
	onChange: PropTypes.func,
};

export default FilterRow;
